import { render, staticRenderFns } from "./LiberacaoContainer.vue?vue&type=template&id=7e87ace8&scoped=true"
import script from "./LiberacaoContainer.vue?vue&type=script&lang=js"
export * from "./LiberacaoContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e87ace8",
  null
  
)

export default component.exports